import { FC } from 'react';

import ControlBarButton from '@3.0/Buttons/ControlBarButtons/ControlBarButton';
import LogsIconComponent from '@3.0/Studio/Ingestion/LogsIconComponent';
import { IOnAddDismissibleLinkProp } from '../../../constants/ingestion.constants';
import { Tooltip } from '@mui/material';

type TProps = {
  showTitle: boolean;
};

const VIEW_LOG_TEXT = 'View log';

const ViewLogButton: FC<TProps & IOnAddDismissibleLinkProp> = ({
  onAddDismissibleLink,
  showTitle,
}) => {
  return (
    <ControlBarButton
      onClick={onAddDismissibleLink}
      data-testid="view-log-button"
      type="button"
      className="tw:h-10"
    >
      <Tooltip title={!showTitle && VIEW_LOG_TEXT} placement="bottom-end">
        <div className="tw:flex tw:items-center tw:justify-center tw:gap-2">
          <LogsIconComponent />
          {showTitle && <span className="tw:text-sm tw:font-normal">{VIEW_LOG_TEXT}</span>}
        </div>
      </Tooltip>
    </ControlBarButton>
  );
};

export default ViewLogButton;
